<template>
  <div class="fb-wrapper">
    <div
      class="fb-like"
      :data-href="url"
      data-width=""
      data-layout="button"
      data-action="like"
      data-size="small"
      data-share="false"
    />
  </div>
</template>

<script lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'
import { createScript, removeScript } from '@/utils/script'
export default {
  props: {
    url: {
      type: String,
      default: location.href
    }
  },
  setup() {
    const id = 'facebook-jssdk'
    const facebookUrl =
      'https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v9.0'
    onMounted(() => {
      createScript(id, facebookUrl)
    })
    onBeforeUnmount(() => {
      removeScript(id)
    })
  }
}
</script>

<style lang="scss" scoped>
.fb-wrapper {
  position: relative;
  height: 100%;
  width: 80px !important;
  &:hover {
    opacity: 0.7;
  }
}
.fb-like {
  position: absolute;
}
::v-deep .fb-like > span {
  width: 80px !important;
}
::v-deep .fb-like > span > iframe {
  width: 80px !important;
}
</style>
